module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasSeller) ? _c('div', {
    staticClass: "subscribe-wrapper"
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('h1', {
    staticClass: "trade-name",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v(_vm._s(_vm.basicSeller.trade_name || _vm.basicSeller.name))]), _vm._v(" "), (_vm.choosePlan) ? _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('subscribe.attributes.choose_your_plan')))]) : _vm._e(), _vm._v(" "), (_vm.checkout) ? _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('subscribe.attributes.subscriber_information')))]) : _vm._e()]), _vm._v(" "), _c('main', {
    attrs: {
      "role": "main"
    }
  }, [(_vm.choosePlan) ? _c('plan', {
    on: {
      "step": _vm.nextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkout) ? _c('checkout', {
    on: {
      "step": _vm.changeStep
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [(_vm.basicSeller.id) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.basicSeller.trade_name || _vm.basicSeller.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basicSeller.email))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3d6df60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/subscribe/Main.vue
// module id = 834
// module chunks = 1